import script from "./edit-coverage-dates-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-coverage-dates-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__